import { Controller } from "@hotwired/stimulus"

// Envía el formulario automáticamente al cambiar un filtro.
// Los inputs de texto se envían con debounce; los selects, de inmediato.
const DEBOUNCE_MS = 350

export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }

  // Para controles que viven FUERA del <form> y se asocian con form="id"
  // (ej. el "Ordenar" sobre los resultados): envía el form asociado.
  submitForm(event) {
    event.target.form?.requestSubmit()
  }

  submitDebounced() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.submit(), DEBOUNCE_MS)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
